// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext} from 'react';
import {useTranslation, Trans} from 'react-i18next';
import cn from 'classnames';
import {Button} from '../lib/button';
import {Trustpilot} from './trustpilot';
import styles from './afflp_bottom.module.less';
import {Settings_context} from '../settings_ctx';
import {perr} from 'hola_pub_util';

interface i_afflp_bottom {
    pref: string;
    from?: number;
    plan: string;
    cls?: string;
    dark?: boolean;
    title?: string|JSX.Element;
    btn_color?: 'white'|'transparent'|'gray'|'black'|'red'|'rainbow';
    btn_to?: string;
    btn_caption?: string;
    description?: string;
    fix?: number;
}
export const Afflp_bottom = ({pref, from = 0, plan, cls, dark, title,
    btn_color, description, btn_to, btn_caption, fix}:i_afflp_bottom)=>{
    const {t} = useTranslation() as any;
    const {theme} = useContext(Settings_context);
    const to = btn_to || `/premium?ref=${pref}_bottom`+(plan ? `&plan=${plan}`
        : '');
    return <div className={cn(cls)}>
      <div className={theme.container}>
        <div className={styles.bottom}>
          <div className={styles.left_block}>
            <h2>{title || <Trans i18nKey="get_what_you_need"/>}</h2>
            {from ? <p>{t('Start from')} <b>${from}</b> / {t('month')}</p>
              : null}
            {fix ? <p>
              <b className={styles.price}>${fix}</b> / {t('month')}</p> : null}
            <Button size={'md'} round arrow cls={styles.btn}
              to={to} caption={btn_caption||t('Get Hola')}
              color={btn_color} on_click={()=>{
                perr({id: `www_afflp_bottom_click_cta_${pref}`});
              }}/>
          </div>
          <div className={cn(styles.right_block)}>
            <p className={styles.paragraph}>
              <Trans i18nKey={description||''}
                components={{span: <span/>, b: <b/>}}/>
            </p>
              <Trustpilot dark={dark} adaptive/>
          </div>
        </div>
      </div>
    </div>;
};
